import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import * as React from 'react';
export default {
  FontAwesomeIcon,
  faAngleRight,
  React
};